import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";
import {
  formPrefixCls,
  collapsePrefixCls,
  alertPrefixCls,
} from "@/base/components/index";

const useStyles = createStyles(({ token, css }: any) => ({
  drawer: css`
    position: relative;
  `,
  loader: css`
    position: absolute;
    inset: 0;
    margin: auto;
  `,
  sectionRcnAssign: css``,
  sectionAccountAssign: css``,
  sectionAccountSetup: css``,
  sectionAccountAssignMultiple: css``,
  sectionListItem: css`
    .${formPrefixCls}-item {
      margin-block: 0;
    }
  `,
  sectionProduct: css`
    text-align: center;
  `,
  sectionProductCover: css`
    overflow: hidden;
    position: relative;
  `,
  sectionProductImage: css`
    margin: auto;
    max-width: 100%;
    max-height: 180px;
  `,
  sectionProductName: css``,
  sectionHelpStartedCollapse: css``,
  sectionHelpStartedCollapseItem: css`
    background-color: ${token.ColorFigmaNeutralGrayscaleGray10} !important;

    .${collapsePrefixCls}-header {
      padding: 8px !important;
      padding-right: 16px !important;
    }
  `,
  sectionHelpStartedCollapseLabel: css``,
  sectionHelpStartedCollapseIcon: css``,
  sectionFinish: css``,
  sectionFinishAlert: css`
    margin-inline: -16px;
    text-align: center;

    .${alertPrefixCls}-message {
      margin-bottom: 8px;
    }
  `,
}));

export const useModalSubscriptionSetupStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
